import { createSearchPageSlice } from '../../../../pages/Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

const filterFields = {
  Client: 'Client',
  ReportAddress: 'ReportAddress',
  Scenario: 'Scenario',
  // Project: 'Project',
  // PO: 'PO',
  // SiteLocation: 'SiteLocation'
};

const initialFilterState = {
  Client: null,
  ReportAddress: null,
  Scenario: null,
  // Project: null,
  // PO: null,
  // SiteLocation: null
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'FirstName',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'globalUserFilter';
const globalUserFilterSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const globalUserFilterActions = globalUserFilterSlice.actions;
export default globalUserFilterSlice.reducer;
